import React from "react";
import { CollapsePanel } from "./CollapsePanel";
import { DetailGrid, DetailGridItem } from "./DetailGrid";
import { Token } from "./Token";

export const TestInfo = ({ testInfo }) => {
  const testData = testInfo || { icd10Codes: [], cptCodes: [] };
  const { icd10Codes = [], cptCodes = [] } = testData;

  return (
    <div className="mb-2">
      <CollapsePanel labelText="Test Info">
        <DetailGrid className="detail-grid-large">
          <DetailGridItem title="Lab Name" value={testInfo.labName} />
          <DetailGridItem title="Coverage Type" value={testInfo?.coverageType} />
          <DetailGridItem title="Test Name" value={testInfo.name} />

          <DetailGridItem
            title="CPT Codes"
            value={cptCodes.map((c, idx) => (
              <Token key={`${c}-${idx}`} className="me-1">
                {c}
              </Token>
            ))}
          />

          <DetailGridItem
            title="ICD Codes"
            value={icd10Codes.map((c, idx) => (
              <Token key={`${c}-${idx}`} className="me-1">
                {c}
              </Token>
            ))}
          />
          <DetailGridItem title="Order ID" value={testInfo.orderId} />
          <DetailGridItem title="Verified Date Of Service" value={testInfo.dateOfService} />
        </DetailGrid>
      </CollapsePanel>
    </div>
  );
};
